import { render, staticRenderFns } from "./VScroll.vue?vue&type=template&id=60d9c892"
import script from "./VScroll.vue?vue&type=script&lang=js"
export * from "./VScroll.vue?vue&type=script&lang=js"
import style0 from "./VScroll.vue?vue&type=style&index=0&id=60d9c892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports